var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackArrow(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.328 5v2H4.5l3.243 3.243-1.415 1.414L.672 6 6.328.343l1.415 1.414L4.5 5h12.828z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxOCAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjMyODUgNS4wMDAxMVY3LjAwMDExTDQuNTAwMTcgNy4wMDAxMUw3Ljc0MjcgMTAuMjQyNkw2LjMyODQ5IDExLjY1NjhMMC42NzE2MzEgNS45OTk5OUw2LjMyODQ5IDAuMzQzMTRMNy43NDI3IDEuNzU3MzVMNC40OTk5NCA1LjAwMDExTDE3LjMyODUgNS4wMDAxMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };